import React, { Component } from 'react';
import '../styles/listenews.css';
import { list as listNews, remove as removeNews } from '../services/newsService';
import {
  Box,
  Paper,
  Stack,
  Typography,
  Button,
  Checkbox,
  FormControlLabel,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  Pagination,
  Chip,
  Link as MuiLink,
  Tooltip,
  IconButton,
  Menu,
  MenuItem
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import MoreVertIcon from '@mui/icons-material/MoreVert';

class Listenews extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hits: [],
      page: 1,
      total_elem: 0,
      isLoading: false,
      expert: false,
      custom: false,
      free: false,
      menuAnchorEl: null,
      menuItem: null
    };
    this.fetchPage = this.fetchPage.bind(this);
    this.onPageChange = this.onPageChange.bind(this);
    this.onFilterSubmit = this.onFilterSubmit.bind(this);
    this.delete = this.delete.bind(this);
    this.openMenu = this.openMenu.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
    this.fetchPage(1);
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  fetchPage(page) {
    const { expert, custom, free } = this.state;
    this.setState({ isLoading: true });
    listNews(page, expert, custom, free)
      .then((result) => {
        if (!this._isMounted) return;
        this.setState({
          hits: result.news || [],
          page: parseFloat(result.page_nbr) || page,
          total_elem: parseFloat(result.total_elem) || 0,
          isLoading: false
        });
      })
      .catch(() => this.setState({ isLoading: false }));
  }

  onPageChange(e, value) {
    this.fetchPage(value);
  }

  onFilterSubmit(e) {
    e.preventDefault();
    this.fetchPage(1);
  }

  delete(item) {
    removeNews(item._id).then(() => this.fetchPage(this.state.page));
  }

  openMenu(item, e) {
    this.setState({ menuAnchorEl: e.currentTarget, menuItem: item });
  }

  closeMenu() {
    this.setState({ menuAnchorEl: null, menuItem: null });
  }

  render() {
    const { hits, page, total_elem, expert, custom, free } = this.state;
    const pageCount = Math.max(1, Math.ceil((total_elem || 0) / 10));

    return (
      <Box sx={{ p: 2 }}>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems={{ xs: 'stretch', sm: 'center' }} justifyContent="space-between" sx={{ mb: 2 }}>
          <Typography variant="h6">Listes News</Typography>
          <Button component={RouterLink} to="/super-admin/Formnews" variant="contained" size="small">Add</Button>
        </Stack>

        <Box component="form" onSubmit={this.onFilterSubmit} sx={{ mb: 2, display: 'flex', gap: 2, flexWrap: 'wrap' }}>
          <FormControlLabel control={<Checkbox checked={expert} onChange={(e) => this.setState({ expert: e.target.checked })} />} label="Expert" />
          <FormControlLabel control={<Checkbox checked={custom} onChange={(e) => this.setState({ custom: e.target.checked })} />} label="Custom" />
          <FormControlLabel control={<Checkbox checked={free} onChange={(e) => this.setState({ free: e.target.checked })} />} label="Free" />
          <Button type="submit" variant="outlined" size="small">Search</Button>
        </Box>

        <Paper variant="outlined">
          <TableContainer sx={{ maxHeight: '70vh' }}>
            <Table
              size="medium"
              stickyHeader
              sx={{
                tableLayout: 'fixed',
                '& tbody tr:nth-of-type(odd)': { bgcolor: 'action.hover' }
              }}
            >
              <TableHead>
                <TableRow>
                  <TableCell>Langue</TableCell>
                  <TableCell>Sujet</TableCell>
                  <TableCell>Publié</TableCell>
                  <TableCell align="right">Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {hits.map((item) => (
                  <TableRow key={item._id} hover>
                    <TableCell>{item.language}</TableCell>
                    <TableCell sx={{ maxWidth: 400 }}>
                      <Tooltip title={item.subject || ''}>
                        <Typography variant="body2" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                          {item.subject}
                        </Typography>
                      </Tooltip>
                    </TableCell>
                    <TableCell>
                      {item.published ? <Chip size="small" label="publié" color="success" /> : <Chip size="small" label="non publié" color="default" />}
                    </TableCell>
                    <TableCell align="right" sx={{ py: 0 }}>
                      <IconButton size="small" onClick={(e) => this.openMenu(item, e)} aria-label="Plus d'actions">
                        <MoreVertIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
                {hits.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={4} align="center">
                      <Typography variant="body2" color="text.secondary">Aucune donnée</Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <Box sx={{ px: 2, py: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography variant="caption" color="text.secondary">Page {page} / {pageCount}</Typography>
            <Pagination
              page={page}
              count={pageCount}
              onChange={this.onPageChange}
              size="small"
              color="primary"
              showFirstButton
              showLastButton
            />
          </Box>

          <Menu
            anchorEl={this.state.menuAnchorEl}
            open={Boolean(this.state.menuAnchorEl)}
            onClose={this.closeMenu}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            keepMounted
          >
            <MenuItem component={RouterLink} to={this.state.menuItem ? `/super-admin/Formnews?new_id=${this.state.menuItem._id}` : '#'} onClick={this.closeMenu}>
              Edit
            </MenuItem>
            <MenuItem
              onClick={() => { if (this.state.menuItem) this.delete(this.state.menuItem); this.closeMenu(); }}
              sx={{ color: 'error.main' }}
            >
              Delete
            </MenuItem>
          </Menu>
        </Paper>
      </Box>
    );
  }
}

export default Listenews;